import ValidityHelper from '../../../Helpers/ValidityHelper';
import InputTypesEnum from '../../../Enums/InputTypesEnum';
import ReportRunnerService from '../../../Services/ReportRunnerSerivce';
import selectHelper from '../../../Helpers/selectHelper';
import QBOInvoiceReportSearchParams from './QBOInvoiceReportSearchParams';
import CreditMemoStatusOptionsArray from '../../../Enums/CreditMemoStatusOptionsArray';

export default class ExportQBOCreditMemoReportWindowDescription {
  static titleForCreate = 'Export QBO Credit Memo Report';
  static titleForEdit = 'Export QBO Credit Memo Report';
  static itemType = QBOInvoiceReportSearchParams;
  static serviceFunction = ReportRunnerService.RequestQboCreditMemoReport;
  static waitForServiceFunction = () => false;
  static finishButtonLabel = 'Export';
  static messageOnSuccess =
    'File creation has started and your report will be available in your personal download menu soon. You can continue to use the system while your request is being processed.';

  static pagesInGeneralEditWizzard = [
    {
      label: 'General',
      fields: [
        {
          fieldName: 'OfficeId',
          label: 'Office',
          className: 'col-12',
          type: InputTypesEnum.OfficeSelect,
          validityChecker: ValidityHelper.forRequiredSelectField,
        },
        {
          fieldName: 'SearchType',
          label: 'Search Using',
          className: 'col-12',
          type: InputTypesEnum.Select,
          selectvalues: ExportQBOCreditMemoReportWindowDescription.searchTypeValues(),
          validityChecker: ValidityHelper.forRequiredSelectField,
        },
        {
          fieldName: 'NotExportedYet',
          label: 'Not Exported Yet',
          className: 'col-12',
          type: InputTypesEnum.EmptyYesNoSelect,
          validityChecker: ValidityHelper.AlwaysFlawless,
          hide: ExportQBOCreditMemoReportWindowDescription.isExportStatusInputHidden,
        },
        {
          fieldName: 'YrmoList',
          label: 'Revenue Period (yrmo1,yrmo2,...)',
          className: 'col-12',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.AlwaysFlawless,
          hide: ExportQBOCreditMemoReportWindowDescription.isYrmoInputHidden,
        },
        {
          fieldName: 'Statuses',
          label: 'Credit Memo Status',
          className: 'col-12',
          type: InputTypesEnum.MultiChoice,
          selectvalues: CreditMemoStatusOptionsArray,
          validityChecker: ValidityHelper.AlwaysFlawless,
          hide: ExportQBOCreditMemoReportWindowDescription.isYrmoInputHidden,
        },
        {
          fieldName: 'InvoiceIdList',
          label: 'Credit Memos (id1,id2,...)',
          className: 'col-12',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.AlwaysFlawless,
          hide: ExportQBOCreditMemoReportWindowDescription.isCreditMemoIdInputHidden,
        },
        {
          fieldName: 'FinalizedAfter',
          label: 'Memo Finalized After',
          className: 'col-6',
          type: InputTypesEnum.Date,
          validityChecker: ValidityHelper.AlwaysFlawless,
          hide: ExportQBOCreditMemoReportWindowDescription.areFinalizedInputsHidden,
        },
        {
          fieldName: 'FinalizedBefore',
          label: 'Memo Finalized Before',
          className: 'col-6',
          type: InputTypesEnum.Date,
          validityChecker: ValidityHelper.AlwaysFlawless,
          hide: ExportQBOCreditMemoReportWindowDescription.areFinalizedInputsHidden,
        },
      ],
    },
  ];

  static isExportStatusInputHidden(searchItem) {
    if (searchItem.SearchType !== 'Export Status') {
      searchItem.NotExportedYet = null;
      return true;
    }
    return false;
  }

  static isYrmoInputHidden(searchItem) {
    if (searchItem.SearchType !== 'Revenue Periods') {
      searchItem.YrmoList = '';
      return true;
    }
    return false;
  }

  static isCreditMemoIdInputHidden(searchItem) {
    if (searchItem.SearchType !== 'Credit Memo IDs') {
      searchItem.InvoiceIdList = '';
      return true;
    }
    return false;
  }

  static areFinalizedInputsHidden(searchItem) {
    if (searchItem.SearchType !== 'Finalized Before/After') {
      searchItem.FinalizedAfter = null;
      searchItem.FinalizedBefore = null;
      return true;
    }
    return false;
  }

  static searchTypeValues() {
    return selectHelper.generateSelectValues([
      '',
      'Export Status',
      'Revenue Periods',
      'Credit Memo IDs',
      'Finalized Before/After',
    ]);
  }
}
